import { motion } from 'framer-motion';
import { LuArrowRight } from 'react-icons/lu';
import { Card } from '../../../design-system/components';
import AppStoreBadges from '../components/AppStoreBadges';
import LinkButton from '../components/LinkButton';
import { LandingHeader } from '../components/SectionHeading';
import { trackUserEvent } from '../../../utils/reddit-pixel';

export default function FinalCTASection() {
  return (
    <section className="ee-landing-section ee-landing-section--warm">
      <motion.div
        className="ee-landing-container ee-landing-container--narrow"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <Card padding="lg" className="ee-landing-cta">
          <LandingHeader
            title="Your Relationships Are Worth the Effort"
            subtitle="The skills you learn here will transform every conversation you have — with your partner, your kids, your coworkers, and yourself."
          />

          <div className="ee-landing-cta__actions">
            <LinkButton
              to="/register"
              size="lg"
              onClick={() => trackUserEvent('Custom', { customEventName: 'ClickStartFree' })}
              trailingIcon={<LuArrowRight />}
            >
              Begin Your Free Journey
            </LinkButton>
            <LinkButton
              to="/quiz-assessment"
              size="lg"
              variant="secondary"
              onClick={() => trackUserEvent('Custom', { customEventName: 'ClickQuizCTA' })}
            >
              Take the Free Quiz
            </LinkButton>
          </div>

          <div className="ee-landing-cta__stores">
            <AppStoreBadges size="sm" className="ee-landing-stores" />
          </div>
        </Card>
      </motion.div>
    </section>
  );
}
